export default "/images/d6523f2f797c2edb3e30b1cbebd7f8cc.avif";